import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Alert } from '../../../components/atoms'
import { ModalDialog } from '../../../../common/components/molecues';
import { LoadingView } from '../../../../common/components/atoms';

import { ERROR_MESSAGE } from '../../../common/constants.js';
import { validationPassword } from '../../../../common/helper/validation.js';
import { getQuery } from '../../../../common/helper/commonHelper.js';

import logo from '../../../components/atoms/data/logo.png'

/**
 * url: /resetpassword?id=XXXX&onetime=YYYY
 */
class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            passwordDummy: "",
            confirmDummy: "",
            authcodeDummy: "",
            displayAlert: false,
            displayDlg: false,
            errorMessage: "",
            id: "",
            onetime: "",
        }
    }

    componentDidMount() {
        if(this.props.location.search === "") return;

        let query = getQuery(this.props.location.search);
        this.setState({
            id: query["id"],
            onetime: query["onetime"],
        })
    }

    onSuccess = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayDlg: true
        });
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickChangePassword = (e) => {
        if (this.state.passwordDummy === "") {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: "パスワード" + ERROR_MESSAGE["not_entered"],
            });
        } else if (this.state.passwordDummy !== this.state.confirmDummy) {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: ERROR_MESSAGE["discrepancy_password"],
            });
        } else if (this.state.authcodeDummy === "") {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: "認証コード" + ERROR_MESSAGE["not_entered"],
            });
        } else if (this.state.id === "" || this.state.onetime === "") {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: ERROR_MESSAGE["invalid_urlparam"],
            });
        } else {
            if(validationPassword(this.state.passwordDummy)) {
                this.props.dispatch({
                    type: "LoadStart"
                });
                this.props.dispatch({
                    type: 'PWReset_Saga',
                    id: this.state.id,
                    onetime: this.state.onetime,
                    password: this.state.passwordDummy,
                    authcode: this.state.authcodeDummy,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                });
            } else {
                this.refAlert.current.setAlertAnime();
                this.setState({ 
                    displayAlert: true,
                    errorMessage: ERROR_MESSAGE["invalid_password"],
                });
            }
        }
    }

    onClickBack = (e) => {
        this.props.history.push('/login');
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }

    createDlgProps() {
        return {
            display: this.state.displayDlg,
            contents: (
                <div style={{paddingTop: "40px"}}>
                    パスワード変更が完了しました。<br/>
                    新しいパスワードでログインできます。
                </div>
            ),
            controls: {
            }
        }
    }

    render() {
        const propAlert = {
            display: this.state.displayAlert,
            message: this.state.errorMessage,
        }
        const propsDlg = this.createDlgProps();
        return (
            <Body>
                <Logo src={logo} />
                メールで送られてきた認証コードを入力して、<br/>
                パスワードを設定してください。
                <Input>
                    <input autocomplete="new-password" type="text" name="authcodeDummy" value={this.state.authcodeDummy} placeholder="認証コード"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input autocomplete="new-password" type="password" name="passwordDummy" value={this.state.passwordDummy} placeholder="パスワード"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input autocomplete="new-password" type="password" name="confirmDummy" value={this.state.confirmDummy} placeholder="確認用"
                        onChange={this.onChange}></input>
                </Input>
                <Alert ref={this.refAlert} {...propAlert} />
                <Buttons>
                    <Button Color="#0077FF" onClick={this.onClickChangePassword}>
                        パスワード変更
                    </Button>
                    <Button Color="#707070" onClick={this.onClickBack}>
                        戻る
                    </Button>
                </Buttons>
                <ModalDialog {...propsDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
    }
};

const connectedResetPassword = connect(mapStateToProps)(ResetPassword);
export { connectedResetPassword as ResetPassword };

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0;
`;

const Logo = styled.img`
    width: 208px;
    height: 32px;
    margin-bottom: 32px;
`;
const Input = styled.div`
    width: 100%;
    max-width: 320px;
    text-align: center;
    margin: 20px 0;
    font-size: 20px;
    input {
        width: 80%;
        font-size: 20px;
        padding: 10px 20px;
    }
`;

const Buttons = styled.div`
    position: fixed;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
const Button = styled.div`
    font-size: 20px;
    padding: 10px 20px;
    background-color: ${props => (props.Color)};
    color: #fff;
    border-radius: 50px;
    width: 80%;
    text-align: center;
    :nth-of-type(n+2) {
        margin-top: 10px;
    }
`;
